import styled, { css } from 'styled-components';

export const colorPrimary = '#11081F';

const variables = css`
:root {
    --color-primary: #11081F;
    --color-secondary: #59095e;
    --color-tertiary: #FFFFFF;
    --color-quaternary: #CEC6CA;
}`;

export const Container = styled.div`
  display: block;
  position: relative;
  color: #ffffff;
  min-height: 100vh;
`;

export default variables;
